import { PaginatableCollection } from 'domains/base/store/collection';
import { PayoutsCollection, ReferralsCollection } from 'domains/settings/store/collection';

export const state = {
  tierData: {},
  availablePayouts: new PayoutsCollection('created_at'),
  requestedPayouts: new PayoutsCollection('created_at'),
  pendingPayouts: new PayoutsCollection('end_date'),
  payoutTotals: {},
  currentPayout: null,
  currentPayoutDetails: null,

  currentcycleReferrals: new ReferralsCollection(),
  availableReferrals: new ReferralsCollection(),
  requestedReferrals: new ReferralsCollection(),
  paidReferrals: new ReferralsCollection(),
  referralTotals: {},
  currentReferralDetails: null,
  referredUsers: new PaginatableCollection('registration_date'),

  affiliateId: null,
  availableAffiliatePayouts: new PayoutsCollection('created_at'),
  requestedAffiliatePayouts: new PayoutsCollection('created_at'),
  pendingAffiliatePayouts: new PayoutsCollection('end_date'),
  affiliatePayoutTotals: {},
  currentAffiliatePayout: null,

  payoutDeductions: new PaginatableCollection('created_at'),
  currentPayoutDeductionsDetails: null,
};

export const mutations = {
  setPayouts(state, { type, payouts }) {
    state[type].payouts = [...state[type].payouts, ...payouts._embedded.items];
    state[type].initialized = true;
    state[type].total = payouts.total_results;
    state[type]._links = payouts._links;

    if (payouts._embedded.items.length === state[type].limit) {
      state[type].page++;
      state[type].canLoad = true;
    } else {
      state[type].canLoad = false;
    }
  },

  resetPayouts(state, property) {
    state[property].payouts = [];
    state[property].page = 0;
    state[property].canLoad = true;
    state[property].initialized = false;
  },

  setReferrals(state, { type, referrals }) {
    state[type].referrals = [...state[type].referrals, ...referrals._embedded.items];
    state[type].initialized = true;
    state[type].total = referrals.total_results;

    if (referrals._embedded.items.length === state[type].limit) {
      state[type].page++;
      state[type].canLoad = true;
    } else {
      state[type].canLoad = false;
    }
  },

  resetReferrals(state, property) {
    state[property].referrals = [];
    state[property].page = 0;
    state[property].canLoad = true;
    state[property].initialized = false;
  },
};